<div class="modal-header justify-content-center">
  <h4 class="modal-title">{{ title }}</h4>
</div>
<div class="modal-body">
  <p>{{ message }}</p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-danger" (click)="activeModal.close(true)">Confirm</button>
  <button type="button" class="btn btn-outline-secondary" (click)="activeModal.dismiss()">Cancel</button>
</div>
